import React from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import App from "./App";
import { CityProvider } from "./state/CityContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <CityProvider>
        <App />
      </CityProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
